import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Notice } from 'telia-front-react';
import { Disturbance, DisturbanceNotice as DisturbanceNoticeProp, DisturbanceType } from '@config/DisturbanceConfig';
import LanguageStore from '@stores/LanguageStore';
import DisturbanceModalStore from '@stores/DisturbanceModalStore';

interface DisturbanceNoticeProps {
  /**
   * Modal failure properties
   */
  isDealer: boolean;
  notice: DisturbanceNoticeProp;
  disturbanceModalStore?: DisturbanceModalStore;
  languageStore?: LanguageStore;
}

const DisturbanceNotice = (props: DisturbanceNoticeProps): JSX.Element => {
  const {
    isDealer,
    notice,
    disturbanceModalStore,
    languageStore: { currentLocale }
  } = props;
  const disturbance: Disturbance = {} as Disturbance;
  disturbance.id = isDealer === true ? notice.informationalId : '';
  if (!notice.countyNotification) {
    return <></>;
  }

  return (
    <Notice type="error">
      {notice.countyNotification.filter((info) => info.languageCode === currentLocale.code).length === 1
        ? notice.countyNotification.filter((info) => info.languageCode === currentLocale.code)[0].infoText
        : notice.countyNotification[0].infoText}{' '}
      {isDealer ? (
        <span>
          {'('}ID:{' '}
          <Button
            id={notice.informationalId}
            text={notice.informationalId}
            link={true}
            type="employee"
            onClick={(event) => {
              event.preventDefault();
              disturbanceModalStore.openModal(disturbance, DisturbanceType.IncidentDisturbanceInfo);
            }}
          />
          {')'}
        </span>
      ) : (
        <></>
      )}
    </Notice>
  );
};

export default inject('isDealer', 'notice', 'disturbanceModalStore', 'languageStore')(observer(DisturbanceNotice));
